import { render, staticRenderFns } from "./LineNotify.vue?vue&type=template&id=71a53afd&scoped=true"
import script from "./LineNotify.vue?vue&type=script&lang=js"
export * from "./LineNotify.vue?vue&type=script&lang=js"
import style0 from "./LineNotify.vue?vue&type=style&index=0&id=71a53afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a53afd",
  null
  
)

export default component.exports